import { Link } from "react-router-dom";
import { Palette } from "lucide-react";

export const AppearanceLink = () => (
  <Link to="/settings/appearance" title="Appearance" className="shrink-0 p-2 rounded-full text-slate-400 hover:text-amber-300 hover:bg-veil/5 transition-colors" data-testid="appearance-link">
    <Palette className="w-4 h-4" />
  </Link>
);
